// extracted by mini-css-extract-plugin
export default {"story":"Story_story__hYErJ","story__avatar":"Story_story__avatar__Tu6Wt","story__info":"Story_story__info__wGRdx"};